
import React from "react";
import { Link } from "react-router-dom";
import FleetSlider from "../pages/FleetSlider";

export default function HomeContactAndFooter() {
  const handleBackToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSearchSubmit = (e) => e.preventDefault();

  return (
    <>
      <footer id="colophon" className="site-footer footer-primary pc-footer">
        <div className="top-footer">
          <div className="container">
            <div className="row g-4">
              {/* CONTACT */}
              <div className="col-lg-3 col-md-6">
                <aside className="widget">
                  <h3 className="pc-foot-title">CONTACT INFORMATION</h3>

                  <div className="textwidget">
                    <p className="pc-foot-intro">
                      Reach us anytime for bookings and inquiries:
                    </p>

                    <ul className="pc-contact-list">
                      <li>
                        <a href="tel:+919284304420">
                          <i className="fas fa-phone-alt" />
                          +91 92843 04420
                        </a>
                      </li>
                      <li>
                        <a href="tel:+918308844163">
                          <i className="fas fa-phone-alt" />
                          +91 83088 44163
                        </a>
                      </li>
                      <li>
                        <a href="mailto:booking@princecab.com">
                          <i className="fas fa-envelope" />
                          booking@princecab.com
                        </a>
                      </li>
                      <li className="pc-address">
                        <i className="fas fa-map-marker-alt" />
                        <strong>Prince Cabs</strong>
                        <span>
                          Office No 106 2nd Floor, Nilgiri Nest Co-op Housing
                          Society, Pimple Gurav Pune, Pune, Pin – 411027
                        </span>
                      </li>
                    </ul>

                    <div className="pc-map">
                      <iframe
                        title="Prince Cabs Map"
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3156.105050387246!2d73.81402779999999!3d18.600277799999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM2JzAxLjAiTiA3M8KwNDgnNTAuNSJF!5e1!3m2!1sen!2sin!4v1757322243695!5m2!1sen!2sin"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    </div>
                  </div>
                </aside>

                <FleetSlider />
              </div>

              {/* COLUMN 2 */}
              <div className="col-lg-3 col-md-6">
                <aside className="widget">
                  <h3 className="pc-foot-title">OUR SERVICES</h3>

                  {/* Your existing Links kept as-is; only class changes handled by CSS */}
                  <nav className="pc-links">

                    
                    <Link className="darkcoloo d-block" to="/pune-sade-teen-shakti-peeth-cab-on-rent">
                      <i className="fa fa-car darkcolo"></i> Pune to Sade Teen Shakti Peeth Cab on Rent
                    </Link>
                     <Link className="darkcoloo d-block" to="/pune-to-kolhapur-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Kolhapur Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mahabaleshwar-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mahabaleshwar Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-panchgani-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Panchgani Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-goa-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Goa Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-bhimashankar-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Bhimashankar Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-shirdi-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Shirdi Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-ashtavinayak-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Ashtavinayak Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-nashik-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Nashik Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-cabs">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Cabs
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-airport-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Airport Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-aurangabad-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Aurangabad Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-ajanta-ellora-tour-package">
                      <i className="fa fa-car darkcolo"></i> Pune to Ajanta Ellora Tour Package
                    </Link>
                   
                    <Link className="darkcoloo d-block" to="/pune-to-imagica-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Imagica Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-ahmednagar-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Ahmednagar Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-konkan-darshan-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Konkan Darshan Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-sangli-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Sangli Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-lonavala-taxi">
                      <i className="fa fa-car darkcolo"></i> Pune to Lonavala Taxi
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-alibaug-innova-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Alibaug Innova Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-solapur-taxi">
                      <i className="fa fa-car darkcolo"></i> Pune to Solapur Taxi
                    </Link>
                    <Link className="darkcoloo d-block" to="/cab-service-in-pune">
                      <i className="fa fa-car darkcolo"></i> Cab Service in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-outstation-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Outstation Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-lavasa-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Lavasa Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-matheran-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Matheran Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/online-cab-booking-pune">
                      <i className="fa fa-car darkcolo"></i> Online Cab Booking Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/taxi-service-near-me">
                      <i className="fa fa-car darkcolo"></i> Taxi Service Near Me
                    </Link>
                    <Link className="darkcoloo d-block" to="/innova-per-km-rate-for-outstation">
                      <i className="fa fa-car darkcolo"></i> Innova Per Km Rate for Outstation
                    </Link>
                    <Link className="darkcoloo d-block" to="/innova-cabs">
                      <i className="fa fa-car darkcolo"></i> Innova Cabs
                    </Link>
                    <Link className="darkcoloo d-block" to="/innova-crysta-cab-booking">
                      <i className="fa fa-car darkcolo"></i> Innova Crysta Cab Booking
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-innova-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Innova Cab
                    </Link>
                   
                  </nav>
                </aside>
              </div>

              {/* COLUMN 3 */}
              <div className="col-lg-3 col-md-6">
                <aside className="widget">
                  <h3 className="pc-foot-title">OUR SERVICES</h3>
                  <nav className="pc-links">

 <Link className="darkcoloo d-block" to="/book-innova-crysta-for-outstation">
                      <i className="fa fa-car darkcolo"></i> Book Innova Crysta for Outstation
                    </Link>
                    <Link className="darkcoloo d-block" to="/innova-crysta-cab-pune">
                      <i className="fa fa-car darkcolo"></i> Innova Crysta Cab Pune
                    </Link>

                    <Link className="darkcoloo d-block" to="/innova-crysta-taxi">
                      <i className="fa fa-car darkcolo"></i> Innova Crysta Taxi
                    </Link>
                    <Link className="darkcoloo d-block" to="/innova-cab-for-wedding-in-pune">
                      <i className="fa fa-car darkcolo"></i> Innova Cab for Wedding in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/innova-cab-on-rent-in-hadapsar-pune">
                      <i className="fa fa-car darkcolo"></i> Innova Cab on Rent in Hadapsar Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mahabaleshwar-innova-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mahabaleshwar Innova Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-shirdi-innova-cab-booking">
                      <i className="fa fa-car darkcolo"></i> Pune to Shirdi Innova Cab Booking
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-airport-innova-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Airport Innova Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-goa-innova-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Goa Innova Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-ashtavinayak-innova-tour-package">
                      <i className="fa fa-car darkcolo"></i> Pune to Ashtavinayak Innova Tour Package
                    </Link>
                    <Link className="darkcoloo d-block" to="/sedan-cab-service-in-pune">
                      <i className="fa fa-car darkcolo"></i> Sedan Cab Service in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/etios-cab-for-outstation-in-pune">
                      <i className="fa fa-car darkcolo"></i> Etios Cab for Outstation in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/toyota-etios-cab-booking-in-pune">
                      <i className="fa fa-car darkcolo"></i> Toyota Etios Cab Booking in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/swift-dzire-on-rent-pune">
                      <i className="fa fa-car darkcolo"></i> Swift Dzire on Rent Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-shirdi-swift-dzire-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Shirdi Swift Dzire Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mahabaleshwar-swift-dzire-cabs">
                      <i className="fa fa-car darkcolo"></i> Pune to Mahabaleshwar Swift Dzire Cabs
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-dzire-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Dzire Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-gujarat-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Gujarat Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-rajasthan-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Rajasthan Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-indore-cab-booking">
                      <i className="fa fa-car darkcolo"></i> Pune to Indore Cab Booking
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-vijayawada-cabs">
                      <i className="fa fa-car darkcolo"></i> Pune to Vijayawada Cabs
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-bangalore-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Bangalore Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-hyderabad-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Hyderabad Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-belgaum-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Belgaum Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/7-seater-car-on-rent-in-pune">
                      <i className="fa fa-car darkcolo"></i> 7 Seater Car On Rent in Pune
                    </Link>
                   <Link className="darkcoloo d-block" to="/pune-to-mumbai-international-airport-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai International Airport Cab
                    </Link>
                  </nav>
                </aside>
              </div>

              {/* COLUMN 4 */}
              <div className="col-lg-3 col-md-6">
                <aside className="widget">
                  <h3 className="pc-foot-title">OUR SERVICES</h3>
                  <nav className="pc-links">
 

                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-one-way-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai One Way Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-taxi-fare">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Taxi Fare
                    </Link>
                    <Link className="darkcoloo d-block" to="/kia-carens-on-rent-in-pune">
                      <i className="fa fa-car darkcolo"></i> Kia Carens On Rent in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/sedan-cabs-booking-in-pune">
                      <i className="fa fa-car darkcolo"></i> Sedan Cabs Booking in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-station-to-mumbai-cabs-service">
                      <i className="fa fa-car darkcolo"></i> Pune Station to Mumbai Cabs Service
                    </Link>
                    <Link className="darkcoloo d-block" to="/viman-nagar-to-mumbai-cabs">
                      <i className="fa fa-car darkcolo"></i> Viman Nagar to Mumbai Cabs
                    </Link>
                    <Link className="darkcoloo d-block" to="/kondhwa-to-mumbai-cab">
                      <i className="fa fa-car darkcolo"></i> Kondhwa to Mumbai Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/kharadi-to-mumbai-cab">
                      <i className="fa fa-car darkcolo"></i> Kharadi to Mumbai Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/koregaon-park-to-mumbai-cab">
                      <i className="fa fa-car darkcolo"></i> Koregaon Park to Mumbai Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/kalyani-nagar-to-mumbai-taxi">
                      <i className="fa fa-car darkcolo"></i> Kalyani Nagar to Mumbai Taxi
                    </Link>
                    <Link className="darkcoloo d-block" to="/wakad-to-mumbai-cab">
                      <i className="fa fa-car darkcolo"></i> Wakad to Mumbai Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/wagholi-to-mumbai-cab">
                      <i className="fa fa-car darkcolo"></i> Wagholi to Mumbai Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/swift-dzire-on-rent-in-pune">
                      <i className="fa fa-car darkcolo"></i> Swift Dzire On Rent in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/ertiga-cab-booking-in-pune">
                      <i className="fa fa-car darkcolo"></i> Ertiga Cab Booking in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/cab-booking-for-wedding-in-pune">
                      <i className="fa fa-car darkcolo"></i> Cab booking for wedding in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/cab-booking-for-marriage-function-in-pune">
                      <i className="fa fa-car darkcolo"></i> Cab Booking for Marriage function in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/ertiga-on-rent-in-hinjewadi">
                      <i className="fa fa-car darkcolo"></i> Ertiga on Rent in Hinjewadi
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mumbai-ertiga-on-rent">
                      <i className="fa fa-car darkcolo"></i> Pune to Mumbai Ertiga On rent
                    </Link>
                    <Link className="darkcoloo d-block" to="/ertiga-on-rent-in-pune">
                      <i className="fa fa-car darkcolo"></i> Ertiga on Rent in Pune
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-goa-ertiga-on-rent">
                      <i className="fa fa-car darkcolo"></i> Pune to Goa Ertiga on rent
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-mahabaleshwar-ertiga-on-rent">
                      <i className="fa fa-car darkcolo"></i> Pune To mahabaleshwar Ertiga On rent
                    </Link>
                    <Link className="darkcoloo d-block" to="/hadapsar-to-mumbai-cab">
                      <i className="fa fa-car darkcolo"></i> Hadapsar to Mumbai Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/alandi-to-mumbai-cabs-service">
                      <i className="fa fa-car darkcolo"></i> Alandi to Mumbai Cabs Service
                    </Link>
                    <Link className="darkcoloo d-block" to="/one-way-taxi-pune-to-mumbai">
                      <i className="fa fa-car darkcolo"></i> One Way Taxi Pune to Mumbai
                    </Link>
                    <Link className="darkcoloo d-block" to="/mumbai-darshan-cabs">
                      <i className="fa fa-car darkcolo"></i> Mumbai Darshan Cabs
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-to-5-jyotirlinga-cab">
                      <i className="fa fa-car darkcolo"></i> Pune to 5 Jyotirlinga Cab
                    </Link>
                    <Link className="darkcoloo d-block" to="/viman-nagar-to-mumbai-ertiga-on-rent">
                      <i className="fa fa-car darkcolo"></i> Viman Nagar to Mumbai Ertiga On rent
                    </Link>
                    <Link className="darkcoloo d-block" to="/pune-outstation-cabs">
                      <i className="fa fa-car darkcolo"></i> Pune Outstation Cabs
                    </Link>
                  </nav>
                </aside>
              </div>
            </div>
          </div>
        </div>

        {/* bottom bar */}
        <div className="buttom-footer">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="copy-right">
                  <p className="copyright-text">
                    All Rights Reserved &copy;&nbsp;
                    <span className="brand">Prince Cabs</span>{" "}
                    <span id="date">{new Date().getFullYear()}</span> |
                    <span> Developed By </span>
                    <a
                      href="https://www.dexterintelligence.com/"
                      className="brand-link darkcolorr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Dexter Intelligence
                    </a>{" "}
                    | Hosted By{" "}
                    <a
                      href="https://www.urvahosting.com/"
                      className="brand-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Urva Hosting
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* back to top */}
      <a
        id="backTotop"
        href="#"
        className="to-top-icon pc-top"
        onClick={handleBackToTop}
        aria-label="Back to top"
      >
        <i className="fas fa-chevron-up" />
      </a>

      {/* search (unchanged) */}
      <div className="header-search-form">
        <div className="container">
          <div className="header-search-container">
            <form className="search-form" role="search" onSubmit={handleSearchSubmit}>
              <input type="text" name="s" placeholder="Enter your text..." />
            </form>
            <a href="#" className="search-close" onClick={(e) => e.preventDefault()}>
              <i className="fas fa-times" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
